var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#ADA7C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7234 12C27.1108 12 30.6932 15.461 30.8438 19.8531L30.8484 20.125V24.5634L32.3434 27.9824C32.4183 28.1535 32.4568 28.3382 32.4568 28.525C32.4568 29.2728 31.8506 29.8791 31.1027 29.8791L25.9734 29.8808C25.9734 31.6756 24.5184 33.1308 22.7234 33.1308C20.9926 33.1308 19.5778 31.7777 19.4789 30.0716L19.4729 29.8783L14.3545 29.8791C14.1689 29.8791 13.9853 29.8409 13.815 29.767C13.129 29.469 12.8145 28.6714 13.1125 27.9855L14.5984 24.5644V20.1249C14.5991 15.6239 18.2298 12 22.7234 12ZM24.348 29.8783L21.0984 29.8808C21.0984 30.7782 21.826 31.5058 22.7234 31.5058C23.5681 31.5058 24.2623 30.8613 24.3409 30.0372L24.348 29.8783ZM22.7234 13.625C19.1266 13.625 16.2239 16.5221 16.2234 20.125V24.9021L14.7674 28.2541H30.6886L29.2234 24.9032L29.2235 20.1389L29.2195 19.895C29.0991 16.392 26.2351 13.625 22.7234 13.625Z",
    fill: "#1F1D28"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsActive);
export default __webpack_public_path__ + "static/media/notifications-active.2ce93366f1545f6af53b2eea5e0ec526.svg";
export { ForwardRef as ReactComponent };